import React, { memo } from 'react';
import { Select, SelectProps } from '@x5-react-uikit/core';
import { useSelector } from 'react-redux';
import { forRole } from 'containers';
import { STATUS_OPTIONS } from './dictionary';
import { StoreState } from 'store';

type Props = Omit<SelectProps, 'options' | 'label'>;

const StatusSelect: React.FC<Props> = (props) => {
  const user = useSelector((state: StoreState) => state.me.user);

  const filteredOptions = STATUS_OPTIONS.filter(
    (x) => !x.roles.length || forRole(x.roles, user!)
  );

  return <Select {...props} label="Статус" options={filteredOptions} />;
};

export default memo(StatusSelect);
